// import { useAvatar } from './avatar.context'
// import React, { useEffect, useRef } from 'react'
// import { cn } from '../../lib/utils'
// import { Mic, MicOff } from 'lucide-react'
// import { useFormikContext } from 'formik'

// const isCloseToGreen = (color) => {
//   const [red, green, blue] = color
//   const th = 90 // Adjust the threshold values for green detection
//   return green > th && red < th && blue < th
// }

// export function VideoWrap() {
//   const { stream } = useAvatar()
//   const videoRef = useRef(null)
//   // const canvasRef = useRef(null)

//   // useEffect(() => {
//   //   if (!stream) return
//   //   console.log('Stream ready: Video Canvas')
//   //   const renderCanvas = () => {
//   //     const video = videoRef.current
//   //     const canvas = canvasRef.current
//   //     if (!canvas || !video) return
//   //     const ctx = canvas.getContext('2d', { willReadFrequently: true })
//   //     if (!ctx) return

//   //     canvas.width = video.width || 500
//   //     canvas.height = video.height || 500

//   //     ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

//   //     const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
//   //     const data = imageData.data

//   //     for (let i = 0; i < data.length; i += 4) {
//   //       const red = data[i]
//   //       const green = data[i + 1]
//   //       const blue = data[i + 2]

//   //       if (isCloseToGreen([red, green, blue])) {
//   //         data[i + 3] = 0 // Set alpha channel to 0 (transparent)
//   //       }
//   //     }

//   //     ctx.putImageData(imageData, 0, 0)

//   //     return requestAnimationFrame(renderCanvas) // Return the request ID
//   //   }

//   //   const animationFrameId = renderCanvas() // Start the animation loop

//   //   // Clean up function to cancel animation frame
//   //   return () => cancelAnimationFrame(animationFrameId)
//   // }, [stream])

//   useEffect(() => {
//     const videoElement = videoRef.current
//     videoElement.srcObject = stream
//     console.log('Stream attached to video element', stream)
//     videoElement.onloadedmetadata = () => {
//       videoElement.play().catch(console.error)
//     }
//   }, [stream])

//   return (
//     <div className={cn(!stream && 'hidden')}>
//       <video ref={videoRef} autoPlay playsInline />
//       {/* <canvas ref={canvasRef} className={'max-w-full'}></canvas> */}
//     </div>
//   )
// }

// export function ImageWrap() {
//   const { stream } = useAvatar()
//   // const canvasRef = useRef(null)
//   const imageRef = useRef(null)
//   const agent = JSON.parse(localStorage.getItem('agent'))

//   // useEffect(() => {
//   //   console.log('Avatar ready: Image Canvas')
//   //   const image = imageRef.current
//   //   if (!image) return
//   //   const canvas = canvasRef.current
//   //   if (!canvas) return
//   //   const ctx = canvas.getContext('2d', { willReadFrequently: true })
//   //   if (!ctx) return

//   //   const renderCanvas = () => {
//   //     canvas.width = image.width || 500
//   //     canvas.height = image.height || 500
//   //     ctx.drawImage(image, 0, 0, canvas.width, canvas.height)

//   //     const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
//   //     const data = imageData.data

//   //     for (let i = 0; i < data.length; i += 4) {
//   //       const red = data[i]
//   //       const green = data[i + 1]
//   //       const blue = data[i + 2]

//   //       if (isCloseToGreen([red, green, blue])) {
//   //         data[i + 3] = 0 // Set alpha channel to 0 (transparent)
//   //       }
//   //     }

//   //     ctx.putImageData(imageData, 0, 0)
//   //   }

//   //   image.onload = renderCanvas

//   //   renderCanvas()
//   // }, [imageRef])

//   return (
//     <div className={cn(stream && 'hidden')}>
//       <img
//         ref={imageRef}
//         // src={agent?.avatarPreview || '/images/default.png'}
//         src={
//           agent?.gender == 'Female'
//             ? '/images/female_preview.webp'
//             : '/images/male_preview.webp'
//         }
//         alt='avatar'
//         crossOrigin='anonymous'
//       />
//       {/* <canvas ref={canvasRef} className={'max-w-full h-auto'}></canvas> */}
//     </div>
//   )
// }

// function Avatar() {
//   const { endSession, isLoadingSession, onCall, startNewCall } = useAvatar()

//   return (
//     <div className='min-h-[360px] flex items-end flex-col'>
//       <VideoWrap />
//       <ImageWrap />
//       <div className='w-full'>
//         <button
//           type='submit'
//           onClick={() => {
//             onCall ? endSession() : startNewCall()
//           }}
//           className={`w-full border border-white py-3 font-semibold rounded-full transition duration-300 bg-gradient-to-b from-[#0874E2] to-[#065EDA] text-white hover:from-[#065EDA] hover:to-[#054CA8] flex items-center justify-center gap-2`}
//         >
//           {isLoadingSession ? (
//             <>Processing...</>
//           ) : (
//             <>
//               {onCall ? <MicOff size={20} /> : <Mic size={20} />}
//               {onCall ? 'End Call' : 'Start Call'}
//             </>
//           )}
//         </button>
//       </div>
//     </div>
//   )
// }

// export default Avatar


import { Mic, MicOff } from 'lucide-react'
import React, { useEffect, useRef } from 'react'
import { cn } from '../../lib/utils'
import { useAvatar } from './avatar.context'

const isCloseToGreen = (color) => {
  const [red, green, blue] = color
  const th = 90 // Adjust the threshold values for green detection
  return green > th && red < th && blue < th
}

// Circle component to display concentric circles
export function CircleDisplay() {
  const canvasRef = useRef(null)
  
  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return
    
    const ctx = canvas.getContext('2d')
    if (!ctx) return
    
    // Set canvas size
    canvas.width = 320
    canvas.height = 320
    
    // Draw the circles
    const centerX = canvas.width / 2
    const centerY = canvas.height / 2
    
    // Draw outer rings
    for (let i = 0; i < 3; i++) {
      const radius = 60 + (i * 60)
      
      ctx.beginPath()
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2)
      ctx.strokeStyle = `rgba(0, 255, 255, ${0.8 - (i * 0.2)})`
      ctx.lineWidth = 2
      ctx.stroke()
    }
    
    // Draw center circle
    ctx.beginPath()
    ctx.arc(centerX, centerY, 40, 0, Math.PI * 2)
    ctx.fillStyle = 'rgba(0, 255, 255, 0.4)'
    ctx.fill()
    
  }, [])
  
  return (
    <canvas ref={canvasRef} className="w-full h-full max-w-xs mx-auto" />
  )
}

export function VideoWrap() {
  const { stream } = useAvatar()
  const videoRef = useRef(null)

  useEffect(() => {
    const videoElement = videoRef.current
    videoElement.srcObject = stream
    console.log('Stream attached to video element', stream)
    videoElement.onloadedmetadata = () => {
      videoElement.play().catch(console.error)
    }
  }, [stream])

  return (
    <div className={cn(!stream && 'hidden')}>
      <video ref={videoRef} autoPlay playsInline />
    </div>
  )
}

export function ImageWrap() {
  const { stream } = useAvatar()
  const imageRef = useRef(null)
  const agent = JSON.parse(localStorage.getItem('agent'))

  return (
    <div className={cn(stream && 'hidden')}>
      <img
        ref={imageRef}
        src={
          agent?.gender == 'Female'
            ? '/images/female_preview.webp'
            : '/images/male_preview.webp'
        }
        alt='avatar'
        crossOrigin='anonymous'
      />
    </div>
  )
}

function Avatar() {
  const { endSession, isLoadingSession, onCall, startNewCall } = useAvatar()

  return (
    <div className='min-h-[360px] flex flex-col'>
      {/* Add the circles before the video/image content */}
      <div className="flex-grow flex items-center justify-center mb-4">
        {/* <CircleDisplay /> */}
      </div>
      
      {/* Video or Image wrap */}
      <div className="w-full">
        <VideoWrap />
        <ImageWrap />
      </div>
      
      {/* Button */}
      <div className='w-full mt-4'>
        <button
          type='submit'
          onClick={() => {
            onCall ? endSession() : startNewCall()
          }}
          className={`w-full border border-white py-3 font-semibold rounded-full transition duration-300 bg-gradient-to-b from-[#0874E2] to-[#065EDA] text-white hover:from-[#065EDA] hover:to-[#054CA8] flex items-center justify-center gap-2`}
        >
          {isLoadingSession ? (
            <>Processing...</>
          ) : (
            <>
              {onCall ? <MicOff size={20} /> : <Mic size={20} />}
              {onCall ? 'End Call' : 'Start Call'}
            </>
          )}
        </button>
      </div>
    </div>
  )
}

export default Avatar